// Subjects (Customers)
export const GET_SUBJECTS = "/company/subject/find";
export const GET_FINDONE = "/company/subject/find-one";
export const ADD_SUBJECT = "/company/subject";
export const UPDATE_SUBJECT = "/company/subject";
export const DELETE_SUBJECT = "/company/subject";
